import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { getConfigurationTabParams } from '../../pages/logical-devices-page/LogicalDevicesPage.util';

export function useLogicalDeviceConfigurationSelection(): ReturnType<typeof getConfigurationTabParams> {
  const [searchParams] = useSearchParams();

  return useMemo(() => getConfigurationTabParams(searchParams), [searchParams]);
}
